import { Link } from "@inertiajs/react"
import { Badge } from "@/components/ui/Badge"
import { TableRow, TableCell } from "@/components/ui/Table"
import { warehouse_path } from "@/lib/routes"
import { useMarket } from "@/lib/useMarket"
import type { OrgNode } from "../Index"
import ChannelPicker from "./ChannelPicker"

interface Warehouse {
  id: string
  external_id: number
  name: string
  code: string | null
  enabled: boolean
  org_node_id: string | null
  market_node_id: string | null
  sale_channel_node_ids: string[]
}

interface Props {
  warehouse: Warehouse
  channels: OrgNode[]
  nodeLabel: (node: OrgNode) => string
  saving: boolean
  onSave: (warehouse: Warehouse, nodeIds: string[]) => void
}

export default function WarehouseRow({ warehouse: w, channels, nodeLabel, saving, onSave }: Props) {
  const market = useMarket()
  return (
    <TableRow>
      <TableCell className="text-muted-foreground">{w.external_id}</TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          {w.sale_channel_node_ids.length > 0 ? (
            <Link
              href={warehouse_path(market.slug, w.id)}
              className="font-medium text-link hover:underline"
            >
              {w.name}
            </Link>
          ) : (
            <span className="font-medium text-foreground">{w.name}</span>
          )}
          {!w.market_node_id && <Badge variant="secondary">No market</Badge>}
        </div>
      </TableCell>
      <TableCell className="text-muted-foreground">{w.code ?? "—"}</TableCell>
      <TableCell>
        <ChannelPicker
          channels={channels}
          selectedIds={w.sale_channel_node_ids}
          nodeLabel={nodeLabel}
          disabled={saving}
          onSave={(nodeIds) => onSave(w, nodeIds)}
        />
      </TableCell>
    </TableRow>
  )
}
